import { Injectable } from '@angular/core';
import { OnboardingDialogResult } from '@app/+authenticated/shared/onboarding/onboarding-dialog/onboarding-dialog.model';
import { SbDialogService } from '@sb/ui';
import { ModalBundle } from '@shiftbase-com/models';

import { TargetSettingDialogComponent } from '../target-setting/target-setting-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class TargetSettingOnboardingService {
  public constructor(private readonly dialogService: SbDialogService) {}

  public openDialog(originator = 'onboarding') {
    return this.dialogService
      .setSize('xxl')
      .open<TargetSettingDialogComponent, ModalBundle, OnboardingDialogResult>(TargetSettingDialogComponent, {
        data: { originator },
      });
  }
}
